import { Box, Checkbox, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toggleFilter } from 'src/utils/filters'
import { FilterState } from '../ProductsPage'

interface FiltersProps {
  categories: any[]
  filterState: FilterState
  updateFilter: (filterType: string, filters: string[]) => void
}

const Filters: React.FC<FiltersProps> = ({ categories, filterState, updateFilter }) => {
  const { t } = useTranslation()

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = event.target.value
    const newSelectedFilters = toggleFilter(selectedOption, filterState.category)
    updateFilter('category', newSelectedFilters)
  }

  return (
    <Box
      backgroundColor='white'
      borderRadius='lg'
      p={4}
      boxShadow='sm'
      mb={{ base: 4, md: 0 }}
      marginRight={4}
    >
      <VStack align='start' spacing={3}>
        <Text fontWeight='bold'>{t('products.filterProducts')}</Text>
        {categories.map((category) => (
          <Checkbox
            key={category.id}
            value={category.id}
            isChecked={filterState.category.includes(category.id)}
            onChange={handleCheckboxChange}
          >
            {category.label}
          </Checkbox>
        ))}
      </VStack>
    </Box>
  )
}

export default Filters
